import React from 'react';
import {
  useGetWorkerCardsQuery,
  WorkerCardType,
} from 'apollo/generated/client-operations';
import { BadgeSelection } from 'components/badgeChecklist/types';

type UseBadgesToDeactivateArgs = {
  workerId: string;
  cardType: WorkerCardType;
};

export const useBadgesToDeactivate = (
  args: UseBadgesToDeactivateArgs,
): BadgeSelection[] => {
  const { workerId, cardType } = args;
  const { data } = useGetWorkerCardsQuery({
    fetchPolicy: 'no-cache',
    skip: !workerId || !cardType,
    variables: { workerId, workerCardsInput: { cardType } },
  });

  return React.useMemo(() => {
    return (
      data?.getWorker.workerCards.edges.map(({ node: workerCard }) => ({
        workerCard,
        selected: true,
      })) ?? []
    );
  }, [data]);
};
